module.exports = __webpack_public_path__ + "static/media/Tupe9.eaff912b.webp";